<template>
  <div class="spotlight-inner-wrapper">
    <div class="error-container">
      <div class="text-center">
        <img
          :src="require(`@/assets/error-general.svg`)"
          width="61"
          height="61"
          :alt="$t(`message.spotlight.errors.title`)"
        />
      </div>
      <div class="text-center">
        <h2 class="my-4">{{ $t(`message.spotlightV2.errors.title`) }}</h2>
      </div>
    </div>
    <div class="btn-container text-center">
      <MobialisButton
        v-if="!hideAllCloseBtns"
        class="mt-4 col-11"
        :width="currentScreenMediaQuery === 'desktop' ? 'w-auto' : 'w-100'"
        @click="clickButton"
        data-cy="continue"
        >{{ $t(`message.spotlightV2.errors.buttonText`) }}
      </MobialisButton>
    </div>
  </div>
</template>

<script>
import { modalMethods } from '@/mixins';
import log from '@/services/log';

export default {
  name: 'Error',
  mixins: [modalMethods],
  data() {
    return {};
  },
  methods: {
    async clickButton() {
      await this.closeModal().catch(error =>
        log('Error closing Spotlight modal and returning to vehicle page.', error)
      );
    },
  },
};
</script>

<style scoped lang="scss">
.error-container {
  padding-top: 90px;
}
.error-message {
  line-height: 24px;
}
.btn-container {
  margin: 0 -15px;
}
</style>
